/**
 * VisiTour-style palette for Wenco Gebiet pins on the map.
 */
const GEBIET_PALETTE = [
  "#E91E8C",
  "#4CAF50",
  "#2196F3",
  "#F44336",
  "#FF9800",
  "#9C27B0",
  "#00BCD4",
  "#795548",
  "#607D8B",
  "#CDDC39",
  "#3F51B5",
  "#009688"
];

function hashGebiet(gebiet) {
  const text = String(gebiet ?? "");
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 31 + text.charCodeAt(i)) % 2147483647;
  }
  return Math.abs(hash);
}

export function getGebietColor(gebiet) {
  const numeric = parseInt(String(gebiet ?? "").replace(/\D/g, ""), 10);
  const index = Number.isFinite(numeric)
    ? numeric % GEBIET_PALETTE.length
    : hashGebiet(gebiet) % GEBIET_PALETTE.length;
  return GEBIET_PALETTE[index];
}

export function getGebietLabel(gebiet) {
  const value = String(gebiet ?? "").trim();
  return value ? `Gebiet ${value}` : "Gebiet";
}

export function getMemberTerritoryColor(memberId) {
  const numeric = parseInt(String(memberId ?? "").replace(/\D/g, ""), 10);
  const index = Number.isFinite(numeric)
    ? numeric % GEBIET_PALETTE.length
    : hashGebiet(memberId) % GEBIET_PALETTE.length;
  return GEBIET_PALETTE[index];
}
